import { useState } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { DiagnosticsGrid } from '../components/DiagnosticsGrid';
import { HowItWorks } from '../components/HowItWorks';
import { ReportPreview } from '../components/ReportPreview';
import { Pricing } from '../components/Pricing';
import { SafetySection } from '../components/SafetySection';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { Toast, ToastType } from '../components/Toast';
import '../styles/global.css';

export function Home() {
  const [toast, setToast] = useState<{ message: string; type: ToastType; visible: boolean }>({
    message: '',
    type: 'success',
    visible: false
  });

  const showToast = (message: string, type: ToastType = 'success') => {
    setToast({ message, type, visible: true });
  };

  const closeToast = () => {
    setToast(prev => ({ ...prev, visible: false }));
  };

  return (
    <div className="app">
      <Header />
      <main>
        {/* 1. Hero */}
        <Hero />
        
        {/* 2. Diagnostics overview */}
        <div id="free-checks">
          <DiagnosticsGrid onCopySuccess={() => showToast('Command copied to clipboard!', 'success')} />
        </div>
        
        {/* 3. How it works */}
        <div id="how-it-works">
          <HowItWorks />
        </div>
        
        {/* 4. Sample report / AI insights preview */}
        <ReportPreview />
        
        {/* 5. Pricing / CTA */}
        <div id="pricing">
          <Pricing />
        </div>
        
        {/* 6. Safety / trust section */}
        <SafetySection />
        
        {/* 7. FAQ */}
        <FAQ />
      </main>
      
      {/* 8. Footer */}
      <Footer />
      
      <Toast 
        message={toast.message} 
        isVisible={toast.visible} 
        type={toast.type}
        onClose={closeToast} 
      />
    </div>
  );
}

